import { BTTO_PROFILE_COLORS } from "@pages/profile-v2/betto/shared/elements";
import styled, { css } from "styled-components";

const isBetto = window.TENANT === "betto";

const CashbackWrapperStyled = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	width: 100%;
`;

const CashbackContentStyled = styled.div`
	display: flex;
	padding: ${isBetto ? "16px" : "15px"};
	flex-direction: column;
	align-items: stretch;
	gap: 10px;
	flex: 1 0 0;
	width: 100%;
	border-radius: ${isBetto ? "12px" : "20px"};
	background: ${isBetto ? BTTO_PROFILE_COLORS.surface : "var(--profile-page-wrapper-bg)"};
	border: ${isBetto ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};

	@media (min-width: 1024px) {
		padding: ${isBetto ? "20px" : "20px"};
	}
`;

const CashbackListStyled = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
`;

const CashbackStateWrapperStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: ${isBetto ? "32px 16px" : "40px 20px"};
	min-height: ${isBetto ? "240px" : "30vh"};
	text-align: center;
`;

const CashbackStateTitleStyled = styled.div`
	color: ${isBetto ? BTTO_PROFILE_COLORS.text : "#fff"};
	font-size: ${isBetto ? "18px" : "18px"};
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.5px;

	@media (min-width: 768px) {
		font-size: ${isBetto ? "20px" : "22px"};
		line-height: 1.3;
	}
`;

const CashbackStateDescriptionStyled = styled.div`
	color: ${isBetto ? BTTO_PROFILE_COLORS.textMuted : "#a0a3bd"};
	font-size: 12px;
	font-weight: 400;
	line-height: 1.5;
	letter-spacing: 0.3px;
	max-width: 480px;

	@media (min-width: 768px) {
		font-size: 14px;
		line-height: 1.5;
	}
`;

const CashbackRetryButtonStyled = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 40px;
	padding: 0 20px;
	border-radius: ${isBetto ? "8px" : "25px"};
	background: ${isBetto
		? BTTO_PROFILE_COLORS.primary
		: "var(--main-explosive-gradient, #eebf12)"};
	color: ${isBetto ? BTTO_PROFILE_COLORS.primaryText : "#1f232d"};
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	cursor: pointer;
	border: none;
	transition: background 0.2s ease;

	${isBetto &&
	css`
		&:hover:not(:disabled) {
			background: ${BTTO_PROFILE_COLORS.primaryDark};
		}
	`}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

const CashbackRefreshButtonStyled = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 36px;
	padding: 0 18px;
	border-radius: ${isBetto ? "8px" : "18px"};
	background: transparent;
	color: ${isBetto ? BTTO_PROFILE_COLORS.textMuted : "#a0a3bd"};
	font-size: 12px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.3px;
	cursor: pointer;
	border: 1px solid ${isBetto ? BTTO_PROFILE_COLORS.border : "#6e7191"};
	transition:
		color 0.2s ease,
		border-color 0.2s ease,
		background 0.2s ease;

	&:hover:not(:disabled) {
		color: ${isBetto ? BTTO_PROFILE_COLORS.text : "#fff"};
		border-color: ${isBetto ? BTTO_PROFILE_COLORS.borderActive : "#a0a3bd"};
		background: ${isBetto ? BTTO_PROFILE_COLORS.surfaceHover : "transparent"};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export {
	CashbackContentStyled,
	CashbackListStyled,
	CashbackRefreshButtonStyled,
	CashbackRetryButtonStyled,
	CashbackStateDescriptionStyled,
	CashbackStateTitleStyled,
	CashbackStateWrapperStyled,
	CashbackWrapperStyled,
};
